import s from "./priceBlock.module.css";
import {useUserContext} from "../../../contexts";

const PriceBlock = (props) => {
    // Destructured props
    const {
        product,
        // TODO: remove this param later
        vendor = "DEFAULT"
    } = props;

    // Looks for the special price attribute up
    const hasSpecialPrice =
        product.specialPrice && product.specialPrice !== "" && product.specialPrice !== "0,00";

    const productPrice = vendor === "DEFAULT" ? product?.price : product?.tablePrice?.price;

    // TODO: referring to the above "todo" this must be the new solution for the "vendor" flag.
    const [{}, {}, {}, {affiliationData}] = useUserContext();

    return (
        <div className={"flex flex-col items-start gap-2 md:gap-1 mb-[0.5rem]"}>
            <div className={`${s.specialPriceWrapper} ${hasSpecialPrice || vendor !== "DEFAULT" ? '' : 'hidden'}`}>
                <div 
                    className={`${s.lineThrough} dark:border-b-contrast-yellow`}
                    style={{borderBottom: `${(vendor !== "DEFAULT" ? `1px solid #706BFF` : `1px solid red`)}`}}
                />
                <p className={`${s.specialPrice} text-[#555] dark:text-white`}>
                    {product.priceLabel} {product.price}
                </p>
            </div>
            <div className={`flex flex-col md:flex-row items-end gap-[0.2rem]`}>
                <h2
                    className={`font-bold leading-none ${s.productPrice} dark:text-white`}
                    style={{
                        color: vendor === "DEFAULT" ? "#212b36" : (affiliationData?.customizations?.color || "#706BFF"),
                    }}
                >
                    {product.priceLabel} {hasSpecialPrice && vendor === "DEFAULT" ? product.specialPrice : productPrice} <br />
                    {product.installments && product.installments.length > 0 && (
                        <span className={`leading-5 !font-normal ${s.installmentRules} dark:text-white`}>
                            ou {vendor === "DEFAULT" ?
                                product.installments[product.installments.length - 1].label :
                                product?.tablePrice?.installment?.label}
                        </span>
                    )}
                </h2>
            </div>
        </div>
    )
}

export default PriceBlock;
